// Charge la base commune
import './common.js'

import './scss/components/video.scss'

// Scripts librairies
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.requireJs = function (modules, cb) {
  window.require(modules, cb)
}

// pagination
async function getpagination() {
  import(/* webpackChunkName: "pagination" */ './js/components/pagination.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a')
      .off()
      .on('click', function () {
        const h = $('#header').height()
        const p = $(this).parents('.paginate-nav').height()
        $('html').animate(
          { scrollTop: $('#events-pagination').offset().top - h - p - 40 },
          { duration: 300, easing: 'linear' }
        )
      })
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des pages
  const $d = $('.paginate')
  if ($d.length) {
    $d.waypoint(
      function () {
        getpagination()
        this.destroy()
      },
      {
        offset: '100%',
      }
    )
  }

  // css complémentaires à un article en détail
  const $c = $('.text-content')
  if ($c.length) {
    $c.waypoint(
      function () {
        import(/* webpackChunkName: "textContent", webpackPrefetch: true */ './scss/components/textContent.scss')
        this.destroy()
      },
      {
        offset: '100%',
      }
    )
  }

  // gestion des filtres de navigation
  const $c2 = $('.filter-nav')
  if ($c2.length) {
    $c2.waypoint(
      function () {
        import(/* webpackChunkName: "filterNav" */ './scss/components/filterNav.scss').then(() => {
          Waypoint.refreshAll()
        })
        this.destroy()
      },
      {
        offset: '100%',
      }
    )
  }

  // gestion des alertes BS
  const $c3 = $('.alert')
  if ($c3.length) {
    $c3.waypoint(
      function () {
        import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss').then(() => {
          Waypoint.refreshAll()
        })
        this.destroy()
      },
      {
        offset: '100%',
      }
    )
  }

  if ($('#go').length) {
    const target = $('#go')
    $('html').animate(
      { scrollTop: $(target).offset().top - $('#header').height() - 20 },
      { duration: 300, easing: 'linear' },
      function () {
        $('html').animate(
          { scrollTop: $(target).offset().top - $('#header').height() - 20 },
          { duration: 300, easing: 'linear' }
        )
      }
    )
  }
})
